// src/services/api.js
import axios from "axios";
import Swal from "sweetalert2";

/*
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1",
});
*/

const baseURL =
  process.env.NODE_ENV === "development"
    ? ( process.env.REACT_APP_API_URL || "http://localhost:3001/api/v1" )
    : "/api/v1";

const api = axios.create({
  baseURL,
});

// ✅ اضافه کردن Authorization header از localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// مدیریت خطاها
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401 → خروج و انتقال به صفحه ورود
    if (error.response?.status === 401) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("role");
      window.location.href = "/authentication/sign-in"; // ریدایرکت به Login
      return Promise.reject(error);
    }

    // سایر خطاها → نمایش SweetAlert
    const message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      "خطایی در ارتباط با سرور رخ داده است.";
    
    Swal.fire({
      icon: "error",
      title: "خطا",
      text: typeof message === "string" ? message : "عملیات با خطا مواجه شد.",
      confirmButtonText: "باشه",
    });

    return Promise.reject(error);
  }
);

export default api;
